import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationResult } from '@shared/_constants';

@Component({
  selector: 'app-filingtype-info',
  templateUrl: './filingtype-info-dialog.component.html',
})
export class FilingTypeInfoDialogComponent {
  constructor(private activeModal: NgbActiveModal) {}

  public async close() {
    this.activeModal.close(ConfirmationResult.no);
  }
}
